import { sarApi } from '@/apis';

export default {
  /**
   *
   * @param {Function} commit
   * @param {Function} dispatch
   * @param {Object} params
   */
  async initSarDashboard({ commit, dispatch }, params) {
    commit('reset');
    commit('setLoading', true);
    const requests = [
      dispatch('fetchSummary'),
      dispatch('fetchStatuses'),
      dispatch('fetchActivities', params),
    ];
    await Promise.all(requests);
    commit('setLoading', false);
  },
  /**
   *
   * @param {Function} commit
   * @param {Object} rootGetters
   */
  async fetchSummary({ commit, rootGetters }) {
    const token = rootGetters['auth/token'];
    try {
      const response = await sarApi.requestSummary(token);
      commit('setSummary', response.data);
    }
    catch (error) {
      commit('setError', error);
    }
  },
  /**
   *
   * @param {Function} commit
   * @param {Object} rootGetters
   */
  async fetchStatuses({ commit, rootGetters }) {
    const token = rootGetters['auth/token'];
    try {
      const response = await sarApi.requestStatuses(token);
      commit('setStatuses', response.data);
    }
    catch (error) {
      commit('setError', error);
    }
  },
  /**
   *
   * @param {Function} commit
   * @param {Function} dispatch
   * @param {Object} params
   */
  async incrementActivities({ commit, dispatch }, params) {
    commit('setAdding', true);
    await dispatch('fetchActivities', params);
    commit('setAdding', false);
  },
  /**
   *
   * @param {Function} commit
   * @param {Function} dispatch
   * @param {Object} params
   */
  async refreshActivities({ commit, dispatch }, params) {
    commit('setRefreshing', true);
    commit('setItems', []);
    await dispatch('fetchActivities', params);
    commit('setRefreshing', false);
  },
  /**
   *
   * @param {Function} commit
   * @param {Object} rootGetters
   * @param {Object} params
   */
  async fetchActivities({ commit, rootGetters }, params) {
    const token = rootGetters['auth/token'];
    try {
      const response = await sarApi.requestList(token, params);
      if (response.data.result && response.data.result.length > 0) {
        commit('addItems', response.data.result);
      }
      commit('setPaging', response.data.paging);
    }
    catch (error) {
      commit('setError', error);
    }
  },
};
